<header>
  <h1>
    <img class="logo" src="shipa-delivery-logo.svg" />
  </h1>
  <div class="chat-container" (click)="openDialog(); $event.stopPropagation()">
    <img
      src="icons/chat.svg"
      alt="chat"
      height="24"
      width="24"
      class="chat-icon clickable"
    />
    <span class="get-in-touch clickable">Get in Touch</span>
    @if (show()) {
      <div class="chat-box" (click)="$event.stopPropagation()">
        <a href="tel:600574472"><img src="imgs/flag-UAE.svg" />600 574472</a>
        <a href="tel:+965 222 75460"
          ><img src="imgs/flag-Kuwait.svg" />+965 222 75460</a
        >
        <a href="tel:800 5000502"
          ><img src="imgs/flag-KSA.svg" />800 500 0502</a
        >
        <a
          class="chat-button"
          href="https://shipa.com/help-center/"
          target="_blank"
          >Help Center</a
        >
      </div>
    }
  </div>
</header>
